export const GENDER_DROPDOWN = [
  {
    _id: 'Male',
    name: 'Male'
  },
  {
    _id: 'Female',
    name: 'Female'
  },
  {
    _id: 'Other',
    name: 'Other'
  }
];

export const REG_LOCATION = [
  {
    _id: 'Hospital',
    name: 'Hospital'
  }
];

export const REPORT_TYPE = [
  {
    _id: 'bill_wise_collection',
    name: 'Bill Wise Collection'
  },
  {
    _id: 'user_wise_collection',
    name: 'User Wise Collection'
  },
  {
    _id: 'ref-by-collection',
    name: 'Referral By Collection'
  }
];

export const PHARMACY_REPORT_TYPE = [
  {
    _id: 'bill_wise_collection',
    name: 'Bill Wise Collection'
  },
];

export const BALANCE_REGISTER_REPORT_TYPE = [
  {
    _id: 'patient type',
    name: 'Patient Type',
  }
];

export const OPD_PROCEDURE_REPORT_TYPE = [
  {
    _id: 'details',
    name: 'Details'
  },
  {
    _id: 'summary',
    name: 'Summary'
  }
];

export const EMPLOYEE_TYPE = [
  { _id: 'Employee', name: 'Employee' },
  { _id: 'Contractor base', name: 'Contractor base' },
  { _id: 'Self', name: 'Self' },
  { _id: 'Shared', name: 'Shared' },
  { _id: 'Visiting', name: 'Visiting' }
];

export const STAFF_TYPE = [
  {
    _id: 'Doctor',
    name: 'Doctor'
  },
];

export const YES_NO = [
  {
    _id: 'No',
    name: 'No'
  },
  {
    _id: 'Yes',
    name: 'Yes'
  }
];

export const LIMIT_TYPE = [
  {
    _id: 'Amount',
    name: 'Amount'
  },
  {
    _id: 'Percentage',
    name: 'Percentage'
  }
];

export const GROUP_NAME = [
  {
    _id: 'Anesthesia',
    name: 'Anesthesia'
  },
  {
    _id: 'Blood_Bank',
    name: 'Blood Bank'
  },
  {
    _id: 'Cardiac_science',
    name: 'Cardiac Science'
  },
  {
    _id: 'Critical_Care',
    name: 'Critical Care'
  },
  {
    _id: 'Dentistry',
    name: 'Dentistry'
  }
];

export const DOC_TYPE = [
  {
    _id: 'Anthesiologist',
    name: 'Anthesiologist'
  },
  {
    _id: 'Surgeon',
    name: 'Surgeon'
  }
];

export const TITLES = [
  {
    _id: 'Mr.',
    name: 'Mr.'
  },
  {
    _id: 'Mrs.',
    name: 'Mrs.'
  },
  {
    _id: 'Miss',
    name: 'Miss'
  },
  {
    _id: 'Baby',
    name: 'Baby'
  },
  {
    _id: 'Master',
    name: 'Master'
  },
  {
    _id: 'Dr.',
    name: 'Dr.'
  }
];

export const RELIGIONS = [
  {
    _id: 'NA',
    name: 'NA'
  },
  {
    _id: 'Hindu',
    name: 'Hindu'
  },
  {
    _id: 'Muslim',
    name: 'Muslim'
  },
  {
    _id: 'Sikh',
    name: 'Sikh'
  },
  { _id: 'Punjabi', name: 'Punjabi' },
  { _id: 'Parasi', name: 'Parasi' }
];

export const BLOOD_GROUPS = [
  { _id: 'NA', name: 'NA' },
  {
    _id: 'A+',
    name: 'A+'
  },
  {
    _id: 'A-',
    name: 'A-'
  },
  {
    _id: 'B+',
    name: 'B+'
  },
  {
    _id: 'B-',
    name: 'B-'
  },
  {
    _id: 'O-',
    name: 'O-'
  },
  {
    _id: 'O+',
    name: 'O+'
  },
  { _id: 'AB-', name: 'AB-' },
  { _id: 'AB+', name: 'AB+' }
];

export const RESULT_TYPE = [
  {
    _id: 'Dropdown',
    name: 'Dropdown '
  },
  {
    _id: 'Text_Box',
    name: 'Text Box'
  },
  {
    _id: 'Multiple_Selector',
    name: 'Multiple Selector '
  }
];

export const SPONSOR_TYPE = [
  {
    _id: 'General',
    name: 'General'
  },
  {
    _id: 'TPA',
    name: 'TPA'
  },
  {
    _id: 'Insurance',
    name: 'Insurance'
  },
  {
    _id: 'Corporate',
    name: 'Corporate'
  },
  {
    _id: 'PSU',
    name: 'PSU'
  },
  {
    _id: 'Govt',
    name: 'Govt'
  }
];

export const PAYEE = [
  {
    _id: 'Cash',
    name: 'Cash'
  },
  {
    _id: 'Credit',
    name: 'Credit'
  },
  {
    _id: 'FOC',
    name: 'FOC'
  },
  {
    _id: 'Other Receivable TPA',
    name: 'Other Receivable TPA'
  }
];

export const PAYMENT_MODE = [
  {
    _id: 'Cash',
    name: 'Cash'
  },
  {
    _id: 'Credit',
    name: 'Credit'
  }
];

export const SERVICE_TYPE = [
  {
    _id: 'L',
    name: 'LAB'
  },
  {
    _id: 'R',
    name: 'RADIOLOGY'
  },
  {
    _id: 'Pc',
    name: 'PACKAGE'
  },
  {
    _id: 'S',
    name: 'SERVICE'
  },
  {
    _id: 'OT',
    name: 'OT'
  },
  {
    _id: 'SR',
    name: 'SURGERY'
  }
];
export const REFERRAL_TYPE = [
  {
    _id: 'Doctor',
    name: 'Doctor'
  },
  {
    _id: 'Visiting Doctor',
    name: 'Visting Doctor'
  },
  {
    _id: 'Hospital',
    name: 'Hospital'
  },
  {
    _id: 'Marketing',
    name: 'Marketing'
  },
  {
    _id: 'Others',
    name: 'Others'
  }
];

export const NATIONALITY = [
  {
    _id: 'Indian',
    name: 'Indian'
  },
  {
    _id: 'International',
    name: 'International'
  }
];

export const TYPE_OF_CHARGES = [
  {
    _id: 'Lumpsum',
    name: 'Lumpsum'
  },
  {
    _id: 'Hourly',
    name: 'Hourly'
  },

  {
    _id: 'Per day',
    name: 'Per Day'
  }
];

export const MASTER_TYPE = [
  {
    _id: 'Blood_Group',
    name: 'Blood Group'
  },

  {
    _id: 'Floor',
    name: 'floor'
  }
];

export const AVAILABLE_FOR = [
  {
    _id: 'All',
    name: 'All'
  },
  {
    _id: 'Reg Patient',
    name: 'Reg Patient'
  },

  {
    _id: 'Opd Patient',
    name: 'Opd Patient'
  },

  {
    _id: 'Ipd Patient',
    name: 'Ipd Patient'
  }
];

export const DISCOUNT_APPLICABLE_ON = [
  {
    _id: 'All_Services',
    name: 'All Services'
  },
  {
    _id: 'Discountable_Services',
    name: 'Discountable Services'
  }
];

export const DISCOUNT_TYPE = [
  {
    _id: 'Fixed',
    name: 'Fixed'
  },
  {
    _id: 'Variable',
    name: 'Variable'
  }
];

export const CARD_TYPE = [
  {
    _id: 'On Duty',
    name: 'On Duty'
  },
  {
    _id: 'Pensioner',
    name: 'Pensioner'
  }
];

export const RECEIPT_MODE = [
  {
    _id: 'CASH',
    name: 'CASH',
    type: 'cash'
  },
  {
    _id: 'Bank',
    name: 'Bank',
    type: 'bank'
  },
  {
    _id: 'Both',
    name: 'Both',
    type: 'both'
  },
  {
    _id: 'Credit',
    name: 'Credit',
    type: 'bank'
  },
  {
    _id: 'Credit Card',
    name: 'Credit Card',
    type: 'bank'
  },
  {
    _id: 'Debit Card',
    name: 'Debit Card',
    type: 'bank'
  },
  {
    _id: 'UPI',
    name: 'UPI',
    type: 'bank'
  },
  {
    _id: 'RTGS/NEFT/Cheque',
    name: 'RTGS/NEFT/Cheque',
    type: 'bank'
  },
  {
    _id: 'Paytm',
    name: 'Paytm',
    type: 'bank'
  }
];


export const PAY_MODES = [
  {
    _id: 'Bank',
    name: 'Bank',
    type: 'bank'
  },
  {
    _id: 'Credit Card',
    name: 'Credit Card',
    type: 'bank'
  },
  {
    _id: 'Debit Card',
    name: 'Debit Card',
    type: 'bank'
  },
  {
    _id: 'UPI',
    name: 'UPI',
    type: 'bank'
  },
  {
    _id: 'RTGS/NEFT/Cheque',
    name: 'RTGS/NEFT/Cheque',
    type: 'bank'
  },
  {
    _id: 'Paytm',
    name: 'Paytm',
    type: 'bank'
  }
];

export const PAY_MODES_CASH = [
  {
    _id: 'CASH',
    name: 'CASH',
    type: 'cash'
  },
  {
    _id: 'Bank',
    name: 'Bank',
    type: 'bank'
  },
  {
    _id: 'Credit Card',
    name: 'Credit Card',
    type: 'bank'
  },
  {
    _id: 'Debit Card',
    name: 'Debit Card',
    type: 'bank'
  },
  {
    _id: 'UPI',
    name: 'UPI',
    type: 'bank'
  },
  {
    _id: 'RTGS/NEFT/Cheque',
    name: 'RTGS/NEFT/Cheque',
    type: 'bank'
  },
  {
    _id: 'Paytm',
    name: 'Paytm',
    type: 'bank'
  }
];

export const BANK_CASH = [
  {
    _id: 'Bank',
    name: 'Bank',
    type: 'bank'
  },
  {
    _id: 'CASH',
    name: 'CASH',
    type: 'cash'
  }
];

export const BILL_TYPE = [
  {
    _id: 'Cash',
    name: 'Cash'
  },
  {
    _id: 'Credit',
    name: 'Credit'
  },
  {
    _id: 'Free',
    name: 'Free'
  }
];

export const SCHEME_NAME = [
  {
    _id: 'Chiranjeevi Bhav',
    name: 'Chiranjeevi Bhav'
  }
];

export const MLC = [
  {
    _id: 'MLC PI / INJURY',
    name: 'MLC PI / INJURY'
  },
  {
    _id: 'MLC PI',
    name: 'MLC PI'
  },
  {
    _id: 'MLC INJURY',
    name: 'MLC INJURY'
  }
];

export const MARITAL_STATUS = [
  {
    _id: 'Married',
    name: 'Married'
  },
  {
    _id: 'Unmarried',
    name: 'Unmarried'
  }
];

export const ADMISSION_TYPE = [
  {
    _id: 'Normal',
    name: 'Normal'
  },
  {
    _id: 'Emergency',
    name: 'Emergency'
  },
  {
    _id: 'Day Care',
    name: 'Day Care'
  }
];

export const RELATION = [
  {
    _id: 'Self',
    name: 'Self'
  },
  {
    _id: 'Father',
    name: 'Father'
  },
  {
    _id: 'Mother',
    name: 'Mother'
  },
  {
    _id: 'Son',
    name: 'Son'
  },
  {
    _id: 'Daughter',
    name: 'Daughter'
  },
  {
    _id: 'Sister',
    name: 'Sister'
  },
  {
    _id: 'Brother',
    name: 'Brother'
  },
  {
    _id: 'Husband',
    name: 'Husband'
  },
  {
    _id: 'Wife Of',
    name: 'Wife Of'
  },
  {
    _id: 'Brother In Law',
    name: 'Brother In Law'
  },
  {
    _id: 'Sister In Law',
    name: 'Sister In Law'
  },
  {
    _id: 'Uncle',
    name: 'Uncle'
  },
  {
    _id: 'Other',
    name: 'Other'
  }
];

export const PRICE_CATEGORY = [
  {
    _id: 'General',
    name: 'General'
  },
  {
    _id: 'Private',
    name: 'Private'
  },
  {
    _id: 'Deluxe',
    name: 'Deluxe'
  },
  {
    _id: 'ICU',
    name: 'ICU'
  },
  {
    _id: 'Simple',
    name: 'Simple'
  }
];

export const CALCULATION_TYPE = [
  {
    _id: 'Per Day',
    name: 'Per Day'
  },
  {
    _id: 'Per Week',
    name: 'Per Week'
  },
  {
    _id: 'Per Month',
    name: 'Per Month'
  }
];

export const OCCUPY_STATUS = [
  {
    _id: 'F',
    name: 'F'
  },
  {
    _id: 'C',
    name: 'C'
  },
  {
    _id: 'B',
    name: 'B'
  }
];

export const DISCHARGE_MODE = [
  {
    _id: 'Normal',
    name: 'Normal'
  },
  {
    _id: 'Referred_To',
    name: 'Referred To'
  },
  {
    _id: 'Refer',
    name: 'Refer'
  },
  {
    _id: 'Lama',
    name: 'Lama'
  },
  {
    _id: 'Death',
    name: 'Death'
  },
  {
    _id: 'Handover_to_Police',
    name: 'Handover To Police'
  },
  {
    _id: 'Home_isolation',
    name: 'Home Isolation'
  }
];

export const HEALTH_CONDITION = [
  {
    _id: 'Normal',
    name: 'Normal'
  },
  {
    _id: 'Good',
    name: 'Good'
  },
  {
    _id: 'Satisfactory',
    name: 'Satisfactory'
  },
  {
    _id: 'Fair',
    name: 'Fair'
  },
  {
    _id: 'Poor',
    name: 'Poor'
  },
  {
    _id: 'Critical',
    name: 'Critical'
  },
  {
    _id: 'Expired',
    name: 'Expired'
  }
];

export const PAYMENT_TYPE = [
  {
    _id: 'Indoor Advance',
    name: 'Indoor Advance'
  },
  {
    _id: 'Angst Bill',
    name: 'Angst Bill'
  }
];

export const TEST_FOR = [
  {
    _id: 'Male',
    name: 'Male'
  },
  {
    _id: 'Female',
    name: 'Female'
  },
  {
    _id: 'Both',
    name: 'Both'
  }
];

export const FONT_TYPE = [
  {
    _id: 'Normal',
    name: 'Normal'
  }
];

export const AGE_TYPE = [
  {
    _id: 'Y',
    name: 'Y'
  },
  {
    _id: 'M',
    name: 'M'
  },
  {
    _id: 'D',
    name: 'D'
  }
];

export const COLLECTION_SAMPLE = [
  {
    _id: 'Pending',
    name: 'Pending'
  },
  {
    _id: 'Collected',
    name: 'Collected'
  },
  {
    _id: 'All',
    name: 'All'
  }
];

export const SAMPLE_COLLECTION_BOOKING_TYPE = [
  {
    _id: 'All',
    name: 'All'
  },
  {
    _id: 'Lab',
    name: 'Lab'
  },
  {
    _id: 'OPD',
    name: 'OPD'
  },
  {
    _id: 'IPD',
    name: 'IPD'
  },
  {
    _id: 'OPD Indent',
    name: 'OPD Indent'
  },
  {
    _id: 'IPD Indent',
    name: 'IPD Indent'
  }
];

export const DISCHARGE_SUMMARY = [{ _id: 'Discharge Summary', name: 'Discharge Summary' }];
export const MEDICINE_NAME = [
  {
    _id: 'Dolo',
    name: 'Dolo'
  },
  {
    _id: 'PCM',
    name: 'PCM'
  }
];

export const MEDICINE_UNIT = [
  {
    _id: 'Unit',
    name: 'Unit'
  }
];

export const MEDICINE_FREQUENCY = [
  {
    _id: 'frequency',
    name: 'Frequency'
  }
];

export const MEDICINE_DOSE = [
  {
    _id: 'dose',
    name: 'Dose'
  }
];

export const UQC_TYPE = [
  {
    _id: 'measure',
    name: 'Measure'
  },
  {
    _id: 'volume',
    name: 'Volume'
  },
  {
    _id: 'length',
    name: 'Length'
  },
  {
    _id: 'weight',
    name: 'Weight'
  },
  {
    _id: 'area',
    name: 'Area'
  }
];

export const PHARMACY_PRODUCT_TYPE = [
  {
    _id: 'pharmacy product',
    name: 'Pharmacy Product'
  },
  {
    _id: 'general product',
    name: 'General Product'
  },
  {
    _id: 'canteen product',
    name: 'Canteen Product'
  }
];

export const PHARMACY_DRUG_SCHEDULE = [
  {
    _id: 'Schedule H',
    name: 'Schedule H'
  },
  {
    _id: 'Schedule H1',
    name: 'Schedule H1'
  },
  {
    _id: 'Schedule X',
    name: 'Schedule X'
  },
  {
    _id: 'N/A',
    name: 'N/A'
  }
];

export const WAREHOUSE_TYPE_PHARMACY = [
  {
    _id: 'Open Store',
    name: 'Open Store'
  },
  {
    _id: 'Donor',
    name: 'Donor'
  },
  {
    _id: 'Bulk',
    name: 'Bulk'
  },
  {
    _id: 'Quarantine',
    name: 'Quarantine'
  },
  {
    _id: 'Warehouse',
    name: 'Warehouse'
  }
];

export const PHARMACY_SUPPLIER = [
  {
    _id: 'Cash',
    name: 'Cash'
  }
];

export const PHARMACY_INVOICE_FROM = [
  {
    _id: 'Cash',
    name: 'Cash'
  }
];

export const PHARMACY_PRODUCT_TYPE_MENUS = [
  {
    _id: 'Pharmacy Product',
    name: 'Pharmacy Product'
  }
];

export const PHARMACY_TYPE_MENUS = [
  {
    _id: 'Direct',
    name: 'Direct'
  },
  {
    _id: 'Against PO',
    name: 'Against PO'
  },
  {
    _id: 'Against Consignment',
    name: 'Against Consignment'
  },
];

export const PHARMACY_TYPE_MENUS_CONSIGNMENT = [
  {
    _id: 'Direct',
    name: 'Direct'
  },
  {
    _id: 'Against PO',
    name: 'Against PO'
  },
];

export const ADD_TAX_CHARGE_DISCOUNT = [
  {
    _id: 'Discount',
    name: 'Discount'
  }
];

export const PHARMACY_SALE_MODE = [
  {
    _id: 'OPD',
    name: 'OPD'
  },
  {
    _id: 'IPD',
    name: 'IPD'
  },
  {
    _id: 'GENERAL',
    name: 'GENERAL'
  }
];

export const PHARMACY_TAX_TYPE = [
  {
    _id: 'inclusive',
    name: 'Inclusive '
  },
  {
    _id: 'exclusive',
    name: 'Exclusive'
  }
];

export const INV_BALANCE_TYPE = [
  {
    _id: 'Dr',
    name: 'Dr'
  },
  {
    _id: 'Cr',
    name: 'Cr'
  }
];

export const ACCOUNT_GROUP_TYPE = [
  {
    _id: 'PL',
    name: 'PL'
  },
  {
    _id: 'BS',
    name: 'BS'
  }
];

export const APPOINTMENT_SERVICE = [
  {
    _id: 'Consultancy',
    name: 'Consultancy'
  }
];

export const BALANCING_METHOD = [
  {
    _id: 'Bill By Bill',
    name: 'Bill By Bill'
  },
  {
    _id: 'Fifo Base',
    name: 'Fifo Base'
  },
  {
    _id: 'On Account',
    name: 'On Account'
  }
];

export const TRADE_MODE = [
  {
    _id: 'Purchase',
    name: 'Purchase'
  },
  {
    _id: 'Sale',
    name: 'Sale'
  },
  {
    _id: 'Both',
    name: 'Both'
  }
];

export const DEALER_TYPE = [
  {
    _id: 'Registered',
    name: 'Registered'
  },
  {
    _id: 'UnRegistered',
    name: 'UnRegistered'
  },
  {
    _id: 'Composition',
    name: 'Composition'
  },
  {
    _id: 'UnHolder',
    name: 'UnHolder'
  },
  {
    _id: 'ECommerceOpeator',
    name: 'ECommerceOpeator'
  }
];

export const LAB_BOOKING_TYPE = [
  {
    _id: 'Lab',
    name: 'Lab'
  },
  {
    _id: 'Opd Indent',
    name: 'Opd Indent'
  },
  {
    _id: 'Ipd Indent',
    name: 'Ipd Indent'
  },
];

export const MEDICINE_ISSUE_PAY_MODE = [
  {
    _id: 'Credit',
    name: 'Credit'
  }
];

export const BANK_CASH_INDENT_MEDICINE_ISSUE = [
  {
    _id: 'Bank',
    name: 'Bank'
  },
  {
    _id: 'Cash',
    name: 'Cash'
  }
];

export const SERVICE_MASTER_REPORT_TYPE = [
  {
    _id: 'S',
    name: 'S'
  },
  {
    _id: 'R',
    name: 'R'
  },
  {
    _id: 'SR',
    name: 'SR'
  },
  {
    _id: 'PC',
    name: 'PC'
  }
];

export const PATIENT_TYPES = [
  {
    _id: 'OPD',
    name: 'OPD'
  },
  {
    _id: 'IPD',
    name: 'IPD'
  }
];

export const RECEIPT_MODE_INV = [
  {
    _id: 'CASH',
    name: 'CASH',
    type: 'cash'
  },
  {
    _id: 'Bank',
    name: 'Bank',
    type: 'bank'
  },
  {
    _id: 'Credit Card',
    name: 'Credit Card',
    type: 'bank'
  },
  {
    _id: 'Debit Card',
    name: 'Debit Card',
    type: 'bank'
  },
  {
    _id: 'UPI',
    name: 'UPI',
    type: 'bank'
  }
];

export const SURGERY_TYPE = [
  {
    _id: 'MINOR',
    name: 'MINOR'
  },
  {
    _id: 'MAJOR',
    name: 'MAJOR'
  }
];

export const VOUCHER_SERIES_SETUP = [
  {
    _id: 'OPD REGISTRATION',
    name: 'OPD REGISTRATION'
  },
  {
    _id: 'OPD BILLING',
    name: 'OPD BILLING'
  },
  {
    _id: 'IPD REGISTRATION',
    name: 'IPD REGISTRATION'
  },
  {
    _id: 'IPD SERVICE',
    name: 'IPD SERVICE'
  },
  {
    _id: 'PARTIAL CANCELLATION',
    name: 'PARTIAL CANCELLATION'
  },
  {
    _id: 'PAYMENT',
    name: 'PAYMENT'
  },
  {
    _id: 'PARTIAL DISCOUNT',
    name: 'PARTIAL DISCOUNT'
  },
  {
    _id: 'PATIENT DISCHARGE REQUEST',
    name: 'PATIENT DISCHARGE REQUEST'
  },
  {
    _id: 'PATIENT DISCHARGE',
    name: 'PATIENT DISCHARGE'
  },
  {
    _id: 'RECEIPT',
    name: 'RECEIPT'
  },
  {
    _id: 'DISCHARGE SUMMARY',
    name: 'DISCHARGE SUMMARY'
  },
  {
    _id: 'INDOOR BILL MANAGEMENT',
    name: 'INDOOR BILL MANAGEMENT'
  },
  {
    _id: 'TPA BILLING',
    name: 'TPA BILLING'
  },
  {
    _id: 'IPD PATIENT DIAGNOSIS',
    name: 'IPD PATIENT DIAGNOSIS'
  },
  {
    _id: 'MRD RECEIPT VOUCHER',
    name: 'MRD RECEIPT VOUCHER'
  },
  {
    _id: 'MRD FILE REQUISITION',
    name: 'MRD FILE REQUISITION'
  },
  {
    _id: 'MRD FILE ISSUE',
    name: 'MRD FILE ISSUE'
  },
  {
    _id: 'MRD FILE RETURN',
    name: 'MRD FILE RETURN'
  },
  {
    _id: 'OT SCHEDULE',
    name: 'OT SCHEDULE'
  },
  {
    _id: 'INDENT REQUISITION FORM',
    name: 'INDENT REQUISITION FORM '
  },
  {
    _id: 'IPD MEDCINE ISSUE',
    name: 'IPD MEDICINE ISSUE'
  },
  {
    _id: 'IPD MEDICINE RETURN',
    name: 'IPD MEDICINE RETURN'
  },
  {
    _id: 'PROCEDURE REPORT',
    name: 'PROCEDURE REPORT'
  },
  {
    _id: 'OT ENTRY',
    name: 'OT ENTRY'
  },
  {
    _id: 'JR FILE SUBMISSION',
    name: 'JR FILE SUBMISSION'
  },
  {
    _id: 'NURSING HANDOVER FORM',
    name: 'NURSING HANDOVER FORM'
  },
  {
    _id: 'DISCOUNT AUTHORIZATION',
    name: 'DISCOUNT AUTHORIZATION'
  },
  {
    _id: 'RELIVED DISCHARGE PATIENT',
    name: 'RELIEVED DISCHARGE PATIENT'
  },
  {
    _id: 'EMERGENCY IPD REGISTRATION',
    name: 'EMERGENCY IPD REGISTRATION'
  },
  {
    _id: 'TPA CLAIM AMOUNT STATUS',
    name: 'TPA CLAIM AMOUNT STATUS'
  },
  {
    _id: 'RELEASE STATUS',
    name: 'RELEASE STATUS'
  },
  {
    _id: 'INVESTIGATION BOOKING',
    name: 'INVESTIGATION BOOKING'
  },
  {
    _id: 'RETAIL SALE POS',
    name: 'RETAIL SALE POS'
  },
  {
    _id: 'PATIENT RECEIPT VOUCHER',
    name: 'PATIENT RECEIPT VOUCHER'
  },
  {
    _id: 'RECEIPT VOUCHER',
    name: 'RECEIPT VOUCHER'
  },
  {
    _id: 'REFUND VOUCHER',
    name: 'REFUND VOUCHER'
  },
  {
    _id: 'CONSIGNMENT RECEIPT',
    name: 'CONSIGNMENT RECEIPT'
  },
  {
    _id: 'GOOD RECEIPT NOTE',
    name: 'GOOD RECEIPT NOTE'
  },
  {
    _id: 'RADIOLOGY SERVICE BOOKING',
    name: 'RADIOLOGY SERVICE BOOKING'
  },
  {
    _id: 'CONSIGNMENT RETURN',
    name: 'CONSIGNMENT RETURN'
  },
  {
    _id: 'PURCHASE RETURN',
    name: 'PURCHASE RETURN'
  },
  {
    _id: 'RETAIL RETURN',
    name: 'RETAIL RETURN'
  },
  {
    _id: 'INDOOR MEDICINE ISSUE',
    name: 'INDOOR MEDICINE ISSUE'
  },
  {
    _id: 'INDOOR MEDICINE RETURN',
    name: 'INDOOR MEDICINE RETURN'
  },
];

export const STATUS = [
  {
    _id: 'Active',
    name: 'Active'
  },
  {
    _id: 'InActive',
    name: 'InActive'
  }
];

export const RADIOLOGY_STATUS_REPORT = [
  {
    _id: 'procedure_done',
    name: 'Procedure Done'
  },
  {
    _id: 'acknowledged',
    name: 'Acknowledged'
  },
  {
    _id: 'deffered',
    name: 'Deffered'
  },
  {
    _id: 'cancelled',
    name: 'Cancelled'
  }
];

export const BILLING_TYPE_REPORT = [
  {
    _id: 'OPD',
    name: 'OPD'
  },
  {
    _id: 'IPD',
    name: 'IPD'
  },
  {
    _id: 'ALL',
    name: 'ALL'
  }
];

export const DEL_MODE = [
  {
    _id: 'By Sea',
    name: 'By Sea'
  },
  {
    _id: 'By Air',
    name: 'By Air'
  },
  {
    _id: 'By Road',
    name: 'By Road'
  }
];

export const CURRENCY = [
  {
    _id: 'INR',
    name: 'INR'
  }
];

export const THER_CARRIER = [
  {
    _id: 'Transport',
    name: 'Transport'
  }
];

export const PURCHASE_ORDER_TYPE = [
  {
    _id: 'Direct',
    name: 'Direct'
  },
  {
    _id: 'Against Pr',
    name: 'Against Pr'
  },
  {
    _id: 'Against Inter Organisation',
    name: 'Against Inter Organisation'
  },
  {
    _id: 'For Consginement',
    name: 'For Consignment'
  },
  {
    _id: 'Against Quotation',
    name: 'Against Qoutation'
  }
];


export const DIET_TYPE = [
  {
    _id: 'Liquid',
    name: 'Liquid'
  },
  {
    _id: 'Soft Diet',
    name: 'Soft Diet'
  },
  {
    _id: 'Main Course',
    name: 'Main Course'
  },
];


export const SALARY_TYPE = [
  {
    _id: 'Permanent',
    name: 'Permanent'
  },
  {
    _id: 'Per Visit',
    name: 'Per Visit'
  },
  // {
  //   _id: 'Hourly',
  //   name: 'Hourly'
  // },
  // {
  //   _id: 'Commission',
  //   name: 'Commission'
  // },
  // {
  //   _id: 'Per Visit + Commission',
  //   name: 'Per Visit + Commission'
  // },
  // {
  //   _id: 'Contractual',
  //   name: 'Contractual'
  // },
];

export const SHIFT_TYPE = [
  {
    _id: 'Day',
    name: 'Day'
  },
  {
    _id: 'Night',
    name: 'Night'
  },
  {
    _id: 'Rotating',
    name: 'Rotating'
  },
  {
    _id: 'Flexible',
    name: 'Flexible'
  },
  {
    _id: 'Other',
    name: 'Other'
  },

];



export const CURRENT_STATUS = [
  {
    _id: 'Active',
    name: 'Active'
  },
  {
    _id: 'On Leave',
    name: 'On Leave'
  },
  {
    _id: 'Resigned',
    name: 'Resigned'
  },
  {
    _id: 'Terminated',
    name: 'Terminated'
  },

];


export const BLOOD_BANK_TYPE = [
  {
    _id: 'donor',
    name: 'Donor'
  },
  {
    _id: 'blood bank',
    name: 'Blood Bank'
  },
];


export const TRANSACTION_TYPE_BLOOD_BANK = [
  {
    _id: 'donor',
    name: 'Donor'
  },
  {
    _id: 'cash',
    name: 'Cash'
  },
];

export const STORE_PRODUCT_MASTER_CATEGORY = [
  {
    _id: 'Pharmacy',
    name: 'Pharmacy'
  },
  {
    _id: 'Non Pharmacy',
    name: 'Non Pharmacy'
  },
  {
    _id: 'Lab',
    name: 'Lab'
  },
  {
    _id: 'Radiology',
    name: 'Radiology'
  },
];


export const SERVICE_PERIOD = [
  {
    _id: 'Week',
    name: 'Week'
  },
  {
    _id: 'Month',
    name: 'Month'
  },
  {
    _id: 'Year',
    name: 'Year'
  },
 
];

export const TYPE_OF_ORGANISATION = [
  {
    _id: 'group',
    name: 'Group'
  },
  {
    _id: 'hospital',
    name: 'Hospital'
  },
  {
    _id: 'pharmacy',
    name: 'pharmacy'
  },
  {
    _id: 'lab',
    name: 'lab'
  },
 
];


export const OT_ENTRY_CHECKIN = [
  {
    _id: 'in',
    name: 'In'
  },
  {
    _id: 'out',
    name: 'Out'
  },
];


export const USER_AUTHORITY_LAB_TYPE = [
  {
    _id: 'signoff',
    name: 'Sign OFF'
  },
  {
    _id: 'amend',
    name: 'Amend'
  },
];

export const GRN_CNT= [
  {
    _id: 'grn',
    name: 'GRN'
  },
  {
    _id: 'cnt',
    name: 'CNT'
  },
];


export const REPORT_TYPES= [
  {
    _id: 'LAB',
    name: 'LAB'
  },
  {
    _id: 'RADIOLOGY',
    name: 'RADIOLOGY'
  },
];